import { images } from 'app/design/images';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Image } from 'expo-image';
import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

const MASCOT_WIDTH = 84;
const MASCOT_HEIGHT = 56;
const MOTION_DURATION_MS = 1_800;
const BLINK_LOOP_DURATION_MS = 3_600;

export function SupportReplyTypingBubble() {
  const { t } = useTranslation('one-channel');
  const motionProgress = useSharedValue(0);
  const blinkOpacity = useSharedValue(0);

  useEffect(() => {
    motionProgress.set(withRepeat(withTiming(1, { duration: MOTION_DURATION_MS, easing: Easing.linear }), -1, false));
    blinkOpacity.set(
      withRepeat(
        withSequence(
          withDelay(2_350, withTiming(1, { duration: 65, easing: Easing.inOut(Easing.quad) })),
          withTiming(0, { duration: 85, easing: Easing.inOut(Easing.quad) }),
          withDelay(100, withTiming(1, { duration: 55, easing: Easing.inOut(Easing.quad) })),
          withTiming(0, { duration: 75, easing: Easing.inOut(Easing.quad) }),
          withDelay(BLINK_LOOP_DURATION_MS - 2_730, withTiming(0, { duration: 0 })),
        ),
        -1,
        false,
      ),
    );
    return () => {
      cancelAnimation(motionProgress);
      cancelAnimation(blinkOpacity);
    };
  }, [blinkOpacity, motionProgress]);

  const mascotStyle = useAnimatedStyle(() => {
    const phase = motionProgress.get() * Math.PI * 2;
    return {
      transform: [
        { translateX: Math.sin(phase) * 1.5 },
        { translateY: Math.cos(phase) * 4 - 4 },
        { rotate: `${String(Math.sin(phase) * 2)}deg` },
      ],
    };
  });
  const blinkStyle = useAnimatedStyle(() => ({ opacity: blinkOpacity.get() }));

  return (
    <View
      accessibilityLabel={t('supportReplyPreparing')}
      accessibilityRole="progressbar"
      style={{
        alignSelf: 'flex-start',
        marginBottom: 8,
      }}
    >
      <Animated.View style={[{ height: MASCOT_HEIGHT, width: MASCOT_WIDTH }, mascotStyle]}>
        <Image source={images.supportChatMascotTyping} style={{ height: MASCOT_HEIGHT, width: MASCOT_WIDTH }} />
        <Animated.View pointerEvents="none" style={[{ inset: 0, position: 'absolute' }, blinkStyle]}>
          {[29, 46].map((left) => (
            <View
              key={left}
              style={{
                backgroundColor: '#FFF3DB',
                borderRadius: 8,
                height: 13,
                left,
                position: 'absolute',
                top: 13,
                width: 11,
              }}
            >
              <View
                style={{
                  borderColor: '#0E4767',
                  borderTopWidth: 2,
                  borderTopLeftRadius: 6,
                  borderTopRightRadius: 6,
                  height: 6,
                  left: 1,
                  position: 'absolute',
                  top: 4,
                  width: 9,
                }}
              />
            </View>
          ))}
        </Animated.View>
      </Animated.View>
    </View>
  );
}
